module.exports = "https://99designs-start-assets.imgix.net/js/0d357900c1cb6c64719bd89575401d79.png";